import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.config.productionTip = false

// 配置 Element UI
Vue.use(ElementUI)

// 配置 axios
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '' : 'http://127.0.0.1:8000'
Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
